// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2462": "313c511faf74","5336": "5083bc5218c4","6180": "1602747826c0",}[chunkId] + ".css"
}